import { apiService } from './apiService';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.eternal-health.com/api';

export interface ActiveUsersMetric {
  activeUsers: number;
  since: string;
}

export interface AvgAdherenceMetric {
  avgAdherence: number;
  activeUsersSince: string;
  adherenceSince: string;
}

export interface UsersWithCustomRemindersMetric {
  usersWithCustomReminders: number;
}

export interface AvgChatMessagesMetric {
  avgChatMessages: number;
  activeUsers: number;
  since: string;
}

export interface MealRecordPhotoVsDescriptionMetric {
  total: number;
  withPhoto: number;
  photoPercentage: number;
  withDescriptionOnly: number;
  descriptionOnlyPercentage: number;
}

export interface ActiveUsersWithNotificationsMetric {
  activeUsers: number;
  withNotifications: number;
  percentage: number;
  since: string;
}

export const adminMetricsService = {
  getActiveUsers: async (): Promise<ActiveUsersMetric> => {
    const url = `${API_BASE_URL}/clinic/metrics/active-users/`;
    try {
      const response = await apiService.get(url);
      return response;
    } catch (error) {
      console.error('Error fetching active users metric:', error);
      throw error;
    }
  },

  getAvgAdherence: async (): Promise<AvgAdherenceMetric> => {
    const url = `${API_BASE_URL}/clinic/metrics/avg-adherence/`;
    try {
      const response = await apiService.get(url);
      return response;
    } catch (error) {
      console.error('Error fetching avg adherence metric:', error);
      throw error;
    }
  },

  getUsersWithCustomReminders: async (): Promise<UsersWithCustomRemindersMetric> => {
    const url = `${API_BASE_URL}/clinic/metrics/users-with-custom-reminders/`;
    try {
      const response = await apiService.get(url);
      return response;
    } catch (error) {
      console.error('Error fetching users with custom reminders metric:', error);
      throw error;
    }
  },

  getAvgChatMessages: async (): Promise<AvgChatMessagesMetric> => {
    const url = `${API_BASE_URL}/clinic/metrics/avg-chat-messages/`;
    try {
      const response = await apiService.get(url);
      return response;
    } catch (error) {
      console.error('Error fetching avg chat messages metric:', error);
      throw error;
    }
  },

  getMealRecordPhotoVsDescription: async (): Promise<MealRecordPhotoVsDescriptionMetric> => {
    const url = `${API_BASE_URL}/clinic/metrics/meal-record-photo-vs-description/`;
    try {
      const response = await apiService.get(url);
      return response;
    } catch (error) {
      console.error('Error fetching meal record photo vs description metric:', error);
      throw error;
    }
  },

  getActiveUsersWithNotifications: async (): Promise<ActiveUsersWithNotificationsMetric> => {
    const url = `${API_BASE_URL}/clinic/metrics/active-users-with-notifications/`;
    try {
      const response = await apiService.get(url);
      return response;
    } catch (error) {
      console.error('Error fetching active users with notifications metric:', error);
      throw error;
    }
  },
};
